import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11cd65da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-mobile__content-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "header-mobile__top-content"
}
const _hoisted_3 = {
  key: 1,
  class: "header-mobile__main-content"
}

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderMobile',
  props: {
  showBackAction: { type: Boolean, default: true } /** Whether to show action to navigate back */,
  wideMainContent: { type: Boolean, default: false },
},
  emits: ["go-back"],
  setup(__props, { emit: __emit }) {


const emit = __emit;

const headerMobileEl = ref<HTMLElement>();

const onBackClick = () => {
  const event = new CustomEvent('back-button-triggered', {
    detail: {
      goBack: true,
    },
  });

  headerMobileEl.value?.dispatchEvent(event);

  emit('go-back');
};

return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!
  const _component_x_button = _resolveComponent("x-button")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "headerMobileEl",
    ref: headerMobileEl,
    class: _normalizeClass(['header-mobile', { 'header-mobile--wide': __props.wideMainContent }])
  }, [
    (__props.showBackAction)
      ? (_openBlock(), _createBlock(_component_x_button, {
          key: 0,
          class: "header-mobile__back",
          variant: "clear",
          onClick: onBackClick
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ot_icon, {
              class: "header-mobile__back-icon",
              name: "arrow-left"
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.$slots['top-content'])
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "top-content")
          ]))
        : _createCommentVNode("", true),
      (_ctx.$slots['main-content'])
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "main-content")
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})